import { SET_CHECKOUT_PAYMENT_VALID, STRIPE_IS_FETCHING, STRIPE_SET_ERROR } from 'reducers/actions-types';
import { dispatchError } from 'reducers/helpers';

//@todo create interfaces
function request(stripe) {
    return function(dispatch) {
        dispatch({ type: STRIPE_IS_FETCHING, isFetching: true });

        return stripe.createToken()
            .then((response) => {
                dispatch({ type: SET_CHECKOUT_PAYMENT_VALID, isPaymentMethodValid: !response.error });
                dispatch({ type: STRIPE_IS_FETCHING, isFetching: false });

                if (response.error) {
                    dispatch({ type: STRIPE_SET_ERROR, error: response.error });
                    return Promise.reject(false);
                }

                dispatch({ type: STRIPE_SET_ERROR, error: null });

                if (!response.token) {
                    throw new Error('Unexpected response');
                }

                return response.token.id;
            })
            .catch(e => {
                dispatch({ type: STRIPE_IS_FETCHING, isFetching: false });

                if (e !== false) {
                    dispatchError(dispatch, e, {
                        description: e,
                    });
                }
            });
    };
}

function setError(error) {
    return function(dispatch) {
        dispatch({ type: STRIPE_SET_ERROR, error: error });
    };
}

export default {
    request,
    setError,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/stripe/actions.js